// extracted by mini-css-extract-plugin
export var editInput = "_gu-0";
export var editInputCompact = "_gu-2";
export var editInputLarge = "_gu-1";
export var editInputSmall = "_gu-3";